/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleFromJSON, RoleToJSON, } from './Role';
import { SellerLimitsDTOFromJSON, SellerLimitsDTOToJSON, } from './SellerLimitsDTO';
/**
 * @export
 */
export const UserDTOSellerLimitTierEnum = {
    Basic: 'BASIC',
    Standard: 'STANDARD',
    Premium: 'PREMIUM'
};
/**
 * Check if a given object implements the UserDTO interface.
 */
export function instanceOfUserDTO(value) {
    return true;
}
export function UserDTOFromJSON(json) {
    return UserDTOFromJSONTyped(json, false);
}
export function UserDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'roles': json['roles'] == null ? undefined : (new Set(json['roles'].map(RoleFromJSON))),
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'langKey': json['langKey'] == null ? undefined : json['langKey'],
        'onboarded': json['onboarded'] == null ? undefined : json['onboarded'],
        'shippinglotChildId': json['shippinglotChildId'] == null ? undefined : json['shippinglotChildId'],
        'sellerLimitTier': json['sellerLimitTier'] == null ? undefined : json['sellerLimitTier'],
        'sellerLimits': json['sellerLimits'] == null ? undefined : SellerLimitsDTOFromJSON(json['sellerLimits']),
    };
}
export function UserDTOToJSON(json) {
    return UserDTOToJSONTyped(json, false);
}
export function UserDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'username': value['username'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'roles': value['roles'] == null ? undefined : (Array.from(value['roles']).map(RoleToJSON)),
        'imageUrl': value['imageUrl'],
        'langKey': value['langKey'],
        'onboarded': value['onboarded'],
        'shippinglotChildId': value['shippinglotChildId'],
        'sellerLimitTier': value['sellerLimitTier'],
        'sellerLimits': SellerLimitsDTOToJSON(value['sellerLimits']),
    };
}
